const Footer = () => {
  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "300px", background: "rgb(44, 44, 44)" }}
      >
        <div>
          <img src="/images/logo.png" alt="logo" width="200px" height="130px" />
        </div>
        <h5 className="p-3 text-white">&copy; 2023</h5>
      </div>
    </>
  );
};

export default Footer;
